// ProdavnicaKorpa.jsx
import React, { useEffect, useState, useContext } from 'react';
import CartItem from './components/CartItem';
import { urls } from './api/urls';
import useHttp from '../../../hooks/use-http';
import { icons } from '../../../../shared/icons';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import toast from 'react-hot-toast';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { formatPrice } from '../../../../utils/FormatPrice';
import DetailView from './components/DetailView';
import { TabContext } from '../../../Context/TabContext';
import { useTranslation } from 'react-i18next';

const ProdavnicaKorpa = () => {
  const { t, i18n } = useTranslation();
  const [pregledKorpe, setPregledKorpe] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [dataDeo, setDataDeo] = useState({});
  const [openDetalView, setOpenDetalView] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [dialogSendOpen, setDialogSendOpen] = useState(false);
  const [dialogSaveOpen, setDialogSaveOpen] = useState(false);
  const [textPoslato, setTextPoslato] = useState('');
  const { addTab } = useContext(TabContext);

  const updateTotalItems = (korpa) => {
    const total = korpa.reduce((sum, item) => sum + item.kolicina, 0);
    setTotalItems(total);
  };
  const calculateTotalPrice = (korpa) => {
    const total = korpa.reduce(
      (sum, item) => sum + item.kolicina * item.fakturnaCena,
      0,
    );
    setTotalPrice(total);
  };
  const vratiPregledKorpe = async () => {
    const config = {
      method: 'POST',
      url: urls.VARATI_STAVKE_KORPE,
      data: { id: +localStorage.idFirme },
    };
    const response = await getData(config);
    if (response) {
      setPregledKorpe(response || []);
      updateTotalItems(response);
      calculateTotalPrice(response);
    }
  };

  useEffect(() => {
    vratiPregledKorpe();
  }, []);

  const updateQuantity = (id, newQuantity) => {
    if (newQuantity <= 0) {
      setSelectedItemId(id);
      setDialogOpen(true);
    } else {
      const updatedKorpa = pregledKorpe.map((item) =>
        item.id === id ? { ...item, kolicina: newQuantity } : item,
      );
      setPregledKorpe(updatedKorpa);
      updateTotalItems(updatedKorpa);

      calculateTotalPrice(updatedKorpa); // Dodajte ovo
    }
  };
  const handleNo = async () => {
    toast.dismiss();
    const tab = {
      title: 'Oprema',
      icon: 'fas fa-cogs',
      type: 68,
    };
    addTab(tab);
  };
  const handleYes = async () => {
    toast.dismiss();
    const tab = {
      title: 'Prodavnica',
      icon: 'fas fa-shopping-cart',
      type: 1072,
    };
    addTab(tab);
  };

  const onSaveKorpa = async () => {
    const listaIdKolicina = pregledKorpe.map((item) => ({
      id: item.id,
      kolicina: item.kolicina,
    }));
    const config = {
      method: 'POST',
      url: urls.NARUCIVANJE_IZ_KORPE,
      data: {
        listaIdKolicina: listaIdKolicina,
        konacnoSlanje: 1,
        idKorProm: +localStorage.idKorisnika,
        idDok: pregledKorpe[0].idDok,
      },
    };
    const response = await getData(config);
    if (response.opis === 'uspesno') {
      toast.success(t('messages.savedSuccessfully'));
    } else {
      toast.error(handleErrorMessage(response));
    }
    setDialogSaveOpen(false);
  };

  const onSendKorpa = async () => {
    const listaIdKolicina = pregledKorpe.map((item) => ({
      id: item.id,
      kolicina: item.kolicina,
    }));
    const config = {
      method: 'POST',
      url: urls.NARUCIVANJE_IZ_KORPE,
      data: {
        listaIdKolicina: listaIdKolicina,
        konacnoSlanje: 2,
        idKorProm: +localStorage.idKorisnika,
        idDok: pregledKorpe[0].idDok,
      },
    };
    const response = await getData(config);
    if (response.opis === 'uspesno') {
      // setTextPoslato('Vaša narudžbenica je ušpesno poslata…');
      toast(
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <img
            src="https://img.icons8.com/color/48/000000/ok--v1.png"
            alt="Success"
            style={{ marginRight: '10px' }}
          />
          <div>
            <p>{t('messages.successfullOrder')}</p>
            <div
              style={{
                marginTop: '10px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <button onClick={handleYes} className="btnNo">
                {t('buttons.yes')}
              </button>
              <button onClick={handleNo} className="btnYes">
                {t('buttons.no')}
              </button>
            </div>
          </div>
        </div>,
        {
          position: 'top-center',
          autoClose: false,
          closeOnClick: false,
        },
      );
      vratiPregledKorpe();
    } else {
      toast.error(handleErrorMessage(response));
    }
    setDialogSendOpen(false);
  };
  const handleRemoveItem = async () => {
    console.log('Item ID to remove:', selectedItemId);
    const config = {
      method: 'POST',
      url: urls.UKLONI_IZ_KORPE,
      data: { id: selectedItemId },
    };
    const response = await getData(config);
    if (response.opis) {
      toast.success(t('messages.partSuccessfullyRemoved'));
      vratiPregledKorpe();
    } else {
      toast.error(handleErrorMessage(response));
    }
    setDialogOpen(false);
  };
  const handleCloseDialog = () => {
    const updatedKorpa = pregledKorpe.map((item) =>
      item.id === selectedItemId ? { ...item, kolicina: item.kolicina } : item,
    );
    console.log('first', updatedKorpa);
    setPregledKorpe(updatedKorpa);
    updateTotalItems(updatedKorpa);
    setDialogOpen(false);
  };

  const removeItemFromCart = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedItemId(item.id);
    setDialogOpen(true);
  };
  const handleOpenDetail = async (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    setDataDeo(product);
    setOpenDetalView(true);
    setQuantity(product.kolicina || 0);
    console.log(product);
  };

  const handleSaveNumber = async (e, product) => {
    console.log(product);
    console.log(quantity);
    const config = {
      method: 'POST',
      url: urls.DODAVANJE_U_KORPU,
      data: {
        idKorProm: +localStorage.idKorisnika,
        idKupca: +localStorage.idFirme,
        idMasine: product.idMasine,
        idDela: product.idDela,
        kolicina: quantity,
        indikator: 2,
      },
    };
    const response = await getData(config);
    vratiPregledKorpe();
    console.log(response);
    setOpenDetalView(false);
  };
  const handleCloseSendDialog = () => {
    setDialogSendOpen(false);
  };
  const onSaveOpenKorpa = async () => {
    setDialogSaveOpen(true);
  };

  const handleCloseSaveDialog = async () => {
    setDialogSaveOpen(false);
  };

  return (
    <div className="cart">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          maxWidth: '650px',
        }}
      >
        <div style={{ fontSize: '25px', textAlign: 'center' }}>
          {t('yourCart')}
        </div>
        <div className="count-items">
          <div>{icons.SHOP_ICON_ORANGE}</div>
          <div>{totalItems}</div>
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <div>
          {pregledKorpe.length === 0 ? (
            <div
              style={{
                textAlign: 'left',
                fontWeight: '600',
                fontSize: '25px',
              }}
            >
              <p>{t('yourCartIsEmpty')}</p>
              <p>{textPoslato}</p>
            </div>
          ) : (
            pregledKorpe.map((item) => (
              <CartItem
                key={item.id}
                item={item}
                updateQuantity={updateQuantity}
                removeItemFromCart={removeItemFromCart}
                handleOpenDetail={handleOpenDetail}
              />
            ))
          )}
        </div>
        <div>
          {pregledKorpe.length > 0 && (
            <div className="cart_Fixed">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  textWrap: 'nowrap',
                  border: '1px solid #ff7c00',
                  borderRadius: '20px',
                  padding: '0 5px',
                }}
              >
                <div className="total_price">
                  {t('totalPrice')}:{'   '}
                  <span style={{ fontWeight: 'bold' }}>
                    {formatPrice(totalPrice)}
                  </span>
                </div>
                <span style={{ color: 'gray', fontWeight: '600' }}>EUR</span>
              </div>
              <div
                className="btn-save"
                style={{
                  background: '#fff',
                  color: '#ff7c00',
                  border: '3px solid #ff7c00',
                  height: '50px',
                  width: '100%',
                }}
                onClick={onSaveOpenKorpa}
              >
                {t('buttons.save')}
              </div>
              <div
                className="btn-save"
                style={{
                  height: '50px',
                  width: '100%',
                  border: '3px solid #ff7c00',
                }}
                onClick={() => {
                  setDialogSendOpen(true);
                }}
              >
                {t('buttons.send')}
              </div>
            </div>
          )}
        </div>
      </div>
      <MuiDialog
        maxWidth="xs"
        open={dialogOpen}
        title={t('messages.removeItem')}
        text={t('messages.removeItemQuestion')}
        handleClose={handleCloseDialog}
        handleConfirm={handleRemoveItem}
        deniedText={t('buttons.cancel').toUpperCase()}
        textConfirm={t('buttons.accept').toUpperCase()}
      />
      <MuiDialog
        maxWidth="xs"
        open={dialogSendOpen}
        title={t('messages.sendOrder')}
        text={t('messages.submitOrderQuestion')}
        handleClose={handleCloseSendDialog}
        handleConfirm={onSendKorpa}
        deniedText={t('buttons.cancel').toUpperCase()}
        textConfirm={t('buttons.accept').toUpperCase()}
      />
      <MuiDialog
        maxWidth="xs"
        open={dialogSaveOpen}
        title={t('messages.saveOrdeer')}
        text={t('messages.saveOrderQuestion')}
        handleClose={handleCloseSaveDialog}
        handleConfirm={onSaveKorpa}
        deniedText={t('buttons.cancel').toUpperCase()}
        textConfirm={t('buttons.accept').toUpperCase()}
      />
      <MuiDialog
        maxWidth="md"
        open={openDetalView}
        title={t('details')}
        content={
          <DetailView
            item={dataDeo}
            handleSaveNumber={handleSaveNumber}
            quantity={quantity}
            setQuantity={setQuantity}
          />
        }
        handleClose={() => setOpenDetalView(false)}
        deniedText={t('buttons.close').toUpperCase()}
      />
    </div>
  );
};

export default ProdavnicaKorpa;
